import React from 'react';
import { Navigate } from 'react-router-dom';
import RouteGuard from 'src/components/okta/RouteGuard';
import RouterErrorView from 'src/pages/errors/RouterErrorView';

// Common Views
import SsoView from 'src/pages/auth/SsoView';
import NotFoundView from 'src/pages/errors/NotFoundView';
import ConsumeView from 'src/pages/auth/ConsumeView';
import LogoutView from 'src/pages/auth/LogoutView';
import AuthCheckView from 'src/pages/auth/AuthCheckView';
import IpRestrictionView from 'src/pages/errors/IpRestrictionView';

// Components
import LoginCallback from 'src/components/okta/LoginCallback';

// App Component
import App from 'src/App';
import Bootstrap from 'src/components/Bootstrap';

import home from './home';
import features from './features';
import manage from './manage';
import mycollections from './mycollections';
import reports from './reports';
import admin from './admin';
import team from './team';

const merge = (...list) => {
  const args = Array.prototype.slice.call(list, 0);
  return args.reduce((current, el) => {
    current.push(...(Array.isArray(el) ? el : [el]));
    return current;
  }, []);
};

const routes = [
  {
    path: '/',
    element: <App />,
    errorElement: <RouterErrorView />,
    children: [
      {
        path: 'app',
        element: (
          <RouteGuard>
            <Bootstrap />
          </RouteGuard>
        ),
        children: merge(
          home,
          features,
          manage,
          mycollections,
          reports,
          admin,
          team,
          { path: '/app', element: <Navigate to="/app/home" /> },
          { path: '*', element: <Navigate to="/404" /> }
        )
      },
      {
        path: 'sso',
        element: <SsoView />
      },
      {
        path: 'login/consume',
        element: <ConsumeView redirectTo="/app/home" />
      },
      {
        path: 'login/callback',
        element: <LoginCallback />
      },
      {
        path: 'logout',
        element: <LogoutView />
      },
      {
        path: 'restricted',
        element: <IpRestrictionView />
      },
      {
        path: '404',
        element: <NotFoundView />
      },
      { path: '/', element: <AuthCheckView /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
